import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// State-management
import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
import store from '@redux-state/index';
import './index.css';
import { AppRoutes } from './routes/routes';
import { bootstrapTabSession } from './components/authProvider/tabSession';

import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter(AppRoutes);

export default async () => {
  // Settle this tab's login state first (refresh, duplicated tab, or a new tab
  // vouched for by another open tab), so no page renders with the wrong answer
  // and bounces to /login. Usually a few hundred milliseconds at most.
  await bootstrapTabSession();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        {/* <PersistGate persistor={persistor} loading={<div>Loading...</div>}> */}
          <RouterProvider router={router} />
        {/* </PersistGate> */}
      </Provider>
    </React.StrictMode>
  );

  reportWebVitals();
}